import React, {Component} from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {TextInput} from '../../../../shared';
import {_openModal, _removeModal, _resetPassword} from '../../../store';
import PropTypes from 'prop-types';
import Button from '../../Button';
import Row from '../../Row';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.content.email || '',
      content: props.content,
      title: 'Forgot Password',
    };
  }

  updateEmail = (name, value) => {
    this.setState({[name]: value});
  };

  handleResetPassword = (event) => {
    event.preventDefault();
    this.props.resetPassword(this.state.email);
    this.props.dispatchRemoveModal(this.state.content);
  };

  render() {
    const {email, content, title} = this.state;
    const {dispatchRemoveModal} = this.props;
    return <BaseModal onClose={() => dispatchRemoveModal(content)} size={'sm'} title={title}>
      <form onSubmit={this.handleResetPassword}>
        <TextInput
          dataPoint={{name: 'email', value: email}}
          type='Email'
          placeholder='Email Address...'
          onChange={this.updateEmail}
          required/>
        <Row wrap={true}>
          <Button
            width={'auto'}
            importance={'secondary'}
            size={'md'}
            label={'Cancel'}
            disabled={false}
            action={() => dispatchRemoveModal(content)}>
          </Button>
          <Button
            width={'auto'}
            importance={'primary'}
            size={'md'}
            label={'Reset Password'}
            disabled={false}
            action={'SUBMIT'}>
          </Button>
        </Row>
      </form>
    </BaseModal>;
  }
}

const mapDispatchToProps = dispatch => ({
  resetPassword: email => dispatch(_resetPassword(email)),
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
  openModal: modal => {
    dispatch(_openModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(ForgotPassword);

ForgotPassword.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    componentName: PropTypes.string.isRequired,
    email: PropTypes.string,
  }),
  dispatchRemoveModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
};
